import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import swal from 'sweetalert';

const staticRequests = [
  {
    _id: "1",
    name: "Arun Kumar",
    city: "Chennai",
    requestedAt: "2025-10-28T10:15:00Z",
    status: "Open",
    email: "arun@gmail.com",
    requestfor: "Match Making",
  },
  {
    _id: "2",
    name: "Priya S",
    city: "Coimbatore",
    requestedAt: "2025-10-27T14:30:00Z",
    status: "Approved",
    email: "priya@gmail.com",
    requestfor: "Match Making",
  },
  {
    _id: "3",
    name: "Vikram Raj",
    city: "Madurai",
    requestedAt: "2025-10-26T09:00:00Z",
    status: "Rejected",
    email: "vikram@gmail.com",
    requestfor: "Life",
  },
  {
    _id: "4",
    name: "Meera R",
    city: "Tirunelveli",
    requestedAt: "2025-10-25T16:45:00Z",
    status: "Open",
    email: "meera@gmail.com",
    requestfor: "Match Making",
  },
  {
    _id: "5",
    name: "Senthil K",
    city: "Salem",
    requestedAt: "2025-10-24T11:20:00Z",
    status: "Approved",
    email: "senthil@gmail.com",
    requestfor: "Life",
  },
];

export default function HoroscopeRequests() {
  const history = useNavigate();

  // State to manage request statuses
  const [requests, setRequests] = useState(staticRequests);

  const [filters] = useState({
    name: "",
    email: "",
    status: "",
    requestfor: "",
  });

  // Filter logic
  const processedData = useMemo(() => {
    let data = [...requests];
    return data;
  }, [requests, filters]);

  // Format Date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  // Handle Status Change with Confirmation
  const handleStatusChange = (id, newStatus, event) => {
    const currentRequest = requests.find(req => req._id === id);
    const oldStatus = currentRequest.status;

    // If same status selected, do nothing
    if (oldStatus === newStatus) {
      return;
    }

    // Dynamic message based on new status
    let confirmMessage = "";
    let confirmTitle = "";
    
    if (newStatus === "Approved") {
      confirmTitle = "Approve Request?";
      confirmMessage = "Do you want to approve this horoscope request?";
    } else if (newStatus === "Rejected") {
      confirmTitle = "Reject Request?";
      confirmMessage = "Do you want to reject this horoscope request?";
    } else {
      confirmTitle = "Change Status?";
      confirmMessage = `Do you want to change the status to ${newStatus}?`;
    }

    swal({
      title: confirmTitle,
      text: confirmMessage,
      icon: "warning",
      buttons: {
        cancel: {
          text: "No, Cancel",
          value: false,
          visible: true,
          className: "btn-cancel",
          closeModal: true,
        },
        confirm: {
          text: "Yes, Change it",
          value: true,
          visible: true,
          className: "btn-confirm",
          closeModal: true
        }
      },
      dangerMode: newStatus === "Rejected",
    }).then((willChange) => {
      if (willChange) {
        // User confirmed - update status
        setRequests(prevRequests =>
          prevRequests.map(req =>
            req._id === id ? { ...req, status: newStatus } : req
          )
        );
        toast.success("Status changed successfully!");
      } else {
        // User cancelled - reset dropdown to old value
        // Force re-render by updating state
        setRequests(prevRequests => [...prevRequests]);
      }
    });
  };

  return (
    <>
      <div className="agent-payment-container">
        <h2 className="font-great-vibes" style={{ margin: "0px 20px 20px", color: "#B21919" }}>
          Horoscope Request List
        </h2>

        {/* Table */}
        <table className="payment-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Requested On</th>
              <th>Status</th>
              <th>Request For</th>
            </tr>
          </thead>
          <tbody>
            {processedData.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-data">
                  No records found
                </td>
              </tr>
            ) : (
              processedData.map((row) => (
                <tr key={row._id}>
                  <td style={{ textAlign: "left" }}>
                    <a href="/agent/profile/6912d52e287c800257801612"
                      style={{ textDecoration: "none", color: "#000000" }}>
                      {row.name}
                    </a>
                  </td>
                  <td>{row.email}</td>
                  <td>{formatDate(row.requestedAt)}</td>
                  <td>
                    <select
                      value={row.status}
                      onChange={(e) => handleStatusChange(row._id, e.target.value, e)}
                      className={`status-dropdown ${row.status === "Approved"
                        ? "success"
                        : row.status === "Rejected"
                          ? "failed"
                          : "open"
                        }`}
                    >
                      <option value="Open">Open</option>
                      <option value="Approved">Approved</option>
                      <option value="Rejected">Rejected</option>
                    </select>
                  </td>
                  <td>{row.requestfor}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <style jsx>{`
        .agent-payment-container {
          background: #ffecd6;
          padding: 25px;
          border-radius: 12px;
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
          margin: 20px;
        }

        .payment-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0 10px;
          margin-top: 15px;
          font-size: 18px;
          overflow: hidden;
          border-radius: 10px;
        }

        .payment-table thead tr th {
          text-align: center;
          padding: 14px;
          background: #b21919;
          color: white;
          font-size: 20px;
          font-weight: 600;
        }

        .payment-table thead tr th:first-child {
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
        }

        .payment-table thead tr th:last-child {
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
        }

        .payment-table tbody tr {
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
        }

        .payment-table td {
          padding: 16px 12px;
          text-align: center;
          font-size: 16px;
        }

        /* Status Dropdown */
        .status-dropdown {
          padding: 8px 16px;
          font-size: 14px;
          border-radius: 20px;
          font-weight: 600;
          text-transform: capitalize;
          border: none;
          cursor: pointer;
          min-width: 120px;
          text-align: center;
          transition: all 0.2s ease;
          outline: none;
        }

        .status-dropdown.success {
          color: #1a8735;
          background-color: #ffecd6;
        }

        .status-dropdown.failed {
          color: #c82333;
          background-color: #ffecd6;
        }

        .status-dropdown.open {
          color: #ff8f00;
          background-color: #ffecd6;
        }

        .status-dropdown:hover {
          opacity: 0.8;
        }

        .no-data {
          text-align: center;
          padding: 30px;
          color: #999;
          font-style: italic;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .payment-table {
            font-size: 16px;
          }
          .payment-table th,
          .payment-table td {
            padding: 10px 8px;
            font-size: 14px;
          }
          .status-dropdown {
            font-size: 12px;
            padding: 6px 12px;
            min-width: 100px;
          }
        }
      `}</style>
    </>
  );
}
